import __request__ from "routing/request";
export function createSummaryTemplate(template, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.contentui/summary_templates", template, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(page = 1, page_size = 50, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.contentui/summary_templates", null, { "page": page, "page_size": page_size }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getTemplateMapping(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.contentui/summary_templates/ui_mapping", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteSummaryTemplate(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.contentui/summary_templates/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateSummaryTemplate(id, template, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.contentui/summary_templates/${id}`, template, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getById(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.contentui/summary_templates/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
